import { BehaviorSubject, Subscription, Observable, of } from 'rxjs';
import { WatchFunnelService } from './../../../../services/watch-funnel.service';
import { AccountService } from '../../../../services/account.service';
import { Component, OnInit, EventEmitter } from '@angular/core';
import {
  IFunnel,
  IFunnelStepVariation,
  IFunnelLink,
  IFunnelStep,
} from '../../../../interfaces/graph-types';
import { WatchAccountService } from '../../../../services/watch-account.service';
// import { ModalAddConditionComponent } from '../../../modals/add-condition/modal-add-condition.component';
import { ModalOptions, BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalAddFunnelStepComponent } from '../../../modals/add-funnel-step/modal-add-funnel-step.component';
import { CanDeactivateComponent } from '../../../shared/can-deactivate-guard/can-deactivate-guard';
import { ModalConfirmLeaveComponent } from '../../../modals/confirm-leave/modal-confirm-leave.component';
import { tap } from 'rxjs/operators';
import { FunnelService } from '../../../../services/funnel.service';

@Component({
  selector: '[account-funnel-steps]',
  template: require('./account-funnel-steps.component.pug'),
  styles: [require('./account-funnel-steps.component.css').toString()],
})
export class AccountFunnelStepsComponent
  implements OnInit, CanDeactivateComponent {
  funnel: IFunnel;
  funnelLinks: IFunnelLink[];
  option: number = null;
  routesub: any = null;
  accsub: any = null;
  libsub: any = null;
  campsub: any = null;
  candidateAttributes$: Subscription;
  candidateTags$: Subscription;
  baseVariation: BehaviorSubject<IFunnelStepVariation> = new BehaviorSubject<
    IFunnelStepVariation
  >(null);
  datafeed: BehaviorSubject<IFunnelStepVariation> = new BehaviorSubject<
    IFunnelStepVariation
  >(null);

  img_empty = require('./empty.png').default;

  addFunnelModalRef: BsModalRef;
  addConditionModalRef: BsModalRef;
  confirmLeaveModalRef: BsModalRef;

  subReason: Subscription = null;
  subReasonAdd: Subscription = null;
  funnel_id: string = null;

  private stepFormDirty = false;

  // -------------------------------------------------------------------
  backgroundImg() {
    return 'url(' + this.img_empty + ')';
  }

  // -------------------------------------------------------------------
  constructor(
    private accountService: AccountService,
    private funnelService: FunnelService,
    private watchAccount: WatchAccountService,
    private watchFunnel: WatchFunnelService,
    private modalService: BsModalService,
  ) {}

  // -------------------------------------------------------------------
  selectedVariationId() {
    return this.selected_variation && this.selected_variation.id;
  }

  // -------------------------------------------------------------------
  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    return this.handleExit();
  }

  // -------------------------------------------------------------------
  handleExit(): Observable<boolean> {
    if (!this.stepFormDirty) return of(true);

    this.confirmLeaveModalRef = this.modalService.show(
      ModalConfirmLeaveComponent,
      { ignoreBackdropClick: true, class: 'modal-sm' },
    );

    return (this.confirmLeaveModalRef.content.onClose as EventEmitter<
      boolean
    >).pipe(
      tap(exitConfirmed => {
        if (exitConfirmed) {
          this.stepFormDirty = false;
        }
      }),
    );
  }

  // -------------------------------------------------------------------
  handleStepFormChange(hasChanged: boolean) {
    this.stepFormDirty = hasChanged;
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.campsub = this.watchFunnel.funnelId().subscribe(funnel_id => {
      if (funnel_id) {
        this.funnel_id = funnel_id;
        this.accsub = this.accountService
          .funnel(funnel_id)
          .subscribe(funnel => {
            this.funnel = funnel;
          });
      }
    });

    // pre-fetch custom attributes for steps
    this.candidateAttributes$ = this.accountService
      .queryCandidateAttributes(this.watchAccount.accountId().getValue())
      .subscribe();
    this.candidateTags$ = this.accountService
      .queryCandidateTags(this.watchAccount.accountId().getValue())
      .subscribe();

    // this.libsub = this.accountService
    //   .funnelLinks(this.watchAccount.accountId().getValue())
    //   .subscribe(funnelLinks => {
    //     this.funnelLinks = funnelLinks;
    //   });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.routesub) {
      this.routesub.unsubscribe();
    }
    if (this.accsub) {
      this.accsub.unsubscribe();
    }
    if (this.libsub) {
      this.libsub.unsubscribe();
    }
    if (this.campsub) {
      this.campsub.unsubscribe();
    }
    if (this.subReason) {
      this.subReason.unsubscribe();
    }
    if (this.subReasonAdd) {
      this.subReasonAdd.unsubscribe();
    }
    if (this.candidateAttributes$) {
      this.candidateAttributes$.unsubscribe();
    }
    if (this.candidateTags$) {
      this.candidateTags$.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  getOptionType(optionType: string) {
    if (optionType == 'info') {
      return 1;
    }
    if (optionType == 'input') {
      return 2;
    }
    if (optionType == 'multi') {
      return 3;
    }
    if (optionType == 'dropdown') {
      return 4;
    }
    if (optionType == 'scale') {
      return 5;
    }
    if (optionType == 'url') {
      return 6;
    }
    if (optionType == 'speed') {
      return 7;
    }7
    if (optionType == 'typing') {
      return 8;
    }
    if (optionType == 'file') {
      return 9;
    }
    if (optionType == 'video') {
      return 10;
    }
    if (optionType == 'checkpoint') {
      return 11;
    }
    console.error('unsupported option type: ' + optionType);
    return null;
  }

  selected_variation: IFunnelStepVariation = null;

  // -------------------------------------------------------------------
  selectVariation(variation: IFunnelStepVariation) {
    this.handleExit().subscribe(canExit => {
      if (!canExit) return;
      this.datafeed.next(variation);

      if (this.selected_variation == variation) {
        this.selected_variation = null;
        this.option = null;
        return;
      }

      this.selected_variation = variation;

      this.baseVariation.next(null);
      this.option = this.getOptionType(variation.type);
    });
  }

  copyInProgress = false;
  // -------------------------------------------------------------------
  copyCampayign(funnellink: IFunnelLink) {
    this.copyInProgress = true;
    this.funnelService.copyFunnelFromLibrary(
      this.funnel_id,
      funnellink.id,
      () => {
        if (this.accsub) {
          this.accsub.unsubscribe();
        }
        this.accsub = this.accountService
          .funnel(this.funnel_id)
          .subscribe(funnel => {
            this.funnel = funnel;
            this.copyInProgress = false;
          });
      },
      err => {
        this.copyInProgress = false;
      },
    );
  }

  // -------------------------------------------------------------------
  OpenAddFunnelStepModal() {
    this.handleExit().subscribe(canExit => {
      if (!canExit) return;

      this.option = null;
      this.selected_variation = null;
      this.baseVariation.next(null);
      this.datafeed.next(null);

      const options: ModalOptions = new ModalOptions();
      options.class = 'gray modal-lg';
      options.ignoreBackdropClick = true;
      options.initialState = {
        org_id: 0, //response.organization.id,
      };

      this.addFunnelModalRef = this.modalService.show(
        ModalAddFunnelStepComponent,
        options,
      );

      this.addFunnelModalRef.content.closeBtnName = 'Close';
      if (this.subReasonAdd) {
        this.subReasonAdd.unsubscribe();
      }
      this.subReasonAdd = this.addFunnelModalRef.content.reason.subscribe(
        option => {
          if (option) {
            this.setOption(option);
          }
        },
      );
    });
  }

  // -------------------------------------------------------------------
  trackByFn(index, item) {
    // https://medium.freecodecamp.org/best-practices-for-a-clean-and-performant-angular-application-288e7b39eb6f
    return item.id; // unique id corresponding to the item
  }

  // -------------------------------------------------------------------
  setOption(opt: number) {
    this.option = opt;
    this.selected_variation = null;
  }

  // -------------------------------------------------------------------
  moveStepUp(step: IFunnelStep) {
    this.handleExit().subscribe(canExit => {
      if (!canExit) return;

      this.funnelService.moveStepUp(
        this.watchFunnel.funnelId().value,
        step.id,
        () => {
          this.handleStepUpdate();
        },
        err => {
          // ERROR
        },
      );
    });
  }

  // -------------------------------------------------------------------
  moveStepDown(step: IFunnelStep) {
    this.handleExit().subscribe(canExit => {
      if (!canExit) return;

      this.funnelService.moveStepDown(
        this.watchFunnel.funnelId().value,
        step.id,
        () => {
          this.handleStepUpdate();
        },
        err => {
          // ERROR
        },
      );
    });
  }

  // -------------------------------------------------------------------
  pauseVariation(variation: IFunnelStepVariation) {
    this.handleExit().subscribe(canExit => {
      if (!canExit) return;

      this.funnelService.pauseVariation(
        this.watchFunnel.funnelId().value,
        variation.id,
        () => {
          this.handleStepUpdate();
        },
        err => {
          // ERROR
        },
      );
    });
  }

  // -------------------------------------------------------------------
  unPauseVariation(variation: IFunnelStepVariation) {
    this.handleExit().subscribe(canExit => {
      if (!canExit) return;

      this.funnelService.unPauseVariation(
        this.watchFunnel.funnelId().value,
        variation.id,
        () => {
          this.handleStepUpdate();
        },
        err => {
          // ERROR
        },
      );
    });
  }

  // -------------------------------------------------------------------
  addCondition(variation: IFunnelStepVariation) {
    // this.handleExit().subscribe(canExit => {
    //   if (!canExit) return;
    //   this.addConditionModalRef = this.modalService.show(
    //     ModalAddConditionComponent,
    //     { class: 'gray modal-lg', initialState: { stepVariation: variation } },
    //   );
    //   this.addConditionModalRef.content.closeBtnName = 'Close';
    //   if (this.subReason) {
    //     this.subReason.unsubscribe();
    //   }
    //   this.subReason = this.addConditionModalRef.content.reason.subscribe(
    //     () => {
    //       this.handleStepUpdate();
    //     },
    //   );
    // });
  }

  // -------------------------------------------------------------------
  addVariation(baseVariation: IFunnelStepVariation) {
    this.handleExit().subscribe(canExit => {
      if (!canExit) return;

      this.baseVariation.next(baseVariation);
      this.datafeed.next(null);
      this.stepFormDirty = false;

      let option = this.getOptionType(baseVariation.type);

      this.setOption(option);
    });
  }

  // -------------------------------------------------------------------
  cancel() {
    this.stepFormDirty = false;
    this.option = null;
    this.selected_variation = null;
  }

  // -------------------------------------------------------------------
  handleStepDelete() {
    this.accountService
      .funnel(this.watchFunnel.funnelId().value)
      .subscribe(funnel => {
        if (funnel) {
          this.option = null;
          this.stepFormDirty = false;
          this.funnel = funnel;
        }
      });
  }

  // -------------------------------------------------------------------
  handleStepUpdate(stepVariationId?: string) {
    this.accountService
      .funnel(this.watchFunnel.funnelId().value)
      .subscribe(funnel => {
        if (funnel) {
          const allVariations: IFunnelStepVariation[] = funnel.steps.reduce(
            (variations, step) => [...variations, ...step.variations],
            [],
          );

          const newVariation = allVariations.find(
            ({ id }) => id === (stepVariationId || this.selectedVariationId()),
          );

          if (newVariation) {
            this.datafeed.next(newVariation);
            this.selected_variation = newVariation;
          }

          this.stepFormDirty = false;
          this.funnel = funnel;

          if (this.addConditionModalRef) {
            this.addConditionModalRef.hide();
          }
        }
      });
  }
}
